import React, { useState, useEffect } from 'react';
import { getJdList, getJd, createJd, updateJd, deleteJd } from '../services/jdService';
import JDList from '../components/jd/JDList';
import JDForm from '../components/jd/JDForm';
import JDDetail from '../components/jd/JDDetail';

const JDManagementPage = () => {
  const [jds, setJds] = useState([]);
  const [selectedJd, setSelectedJd] = useState(null);
  const [selectedJdId, setSelectedJdId] = useState(null);
  const [editingJd, setEditingJd] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [page] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  // 加载JD列表
  const loadJds = async () => {
    setLoading(true);
    setError('');
    
    try {
      const response = await getJdList(page, 10);
      setJds(response.items);
      setTotalPages(Math.ceil(response.total / 10));
    } catch (err) {
      setError('加载JD列表失败');
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  // 加载单个JD详情
  const loadJdDetail = async (id) => {
    if (!id) {
      setSelectedJd(null);
      return;
    }
    
    try {
      const jd = await getJd(id);
      setSelectedJd(jd);
    } catch (err) {
      console.error('加载JD详情失败', err);
    }
  };

  // 初始加载
  useEffect(() => {
    loadJds();
  }, [page, loadJds]);

  // 当选择的JD ID变化时，加载详情
  useEffect(() => {
    loadJdDetail(selectedJdId);
  }, [selectedJdId]);

  // 处理JD选择
  const handleSelectJd = (id) => {
    setSelectedJdId(id);
    setEditingJd(null);
  };

  // 处理添加JD
  const handleAddJd = () => {
    setEditingJd({});
    setSelectedJd(null);
    setSelectedJdId(null);
  };

  // 处理编辑JD
  const handleEditJd = (jd) => {
    setEditingJd(jd);
  };

  // 处理删除JD
  const handleDeleteJd = async (id) => {
    if (!window.confirm('确定要删除这个JD吗？')) {
      return;
    }
    
    try {
      await deleteJd(id);
      
      // 重新加载JD列表
      loadJds();
      
      // 如果删除的是当前选中的JD，清除选中状态
      if (selectedJdId === id) {
        setSelectedJd(null);
        setSelectedJdId(null);
      }
    } catch (err) {
      console.error('删除JD失败', err);
    }
  };

  // 处理保存JD
  const handleSaveJd = async (jd) => {
    try {
      if (jd.id) {
        // 更新JD
        await updateJd(jd.id, jd.title, jd.content);
      } else {
        // 创建JD
        await createJd(jd.title, jd.content);
      }
      
      // 重新加载JD列表
      loadJds();
      
      // 清除编辑状态
      setEditingJd(null);
    } catch (err) {
      console.error('保存JD失败', err);
      throw err;
    }
  };

  // 处理取消编辑
  const handleCancelEdit = () => {
    setEditingJd(null);
  };

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-6 h-[calc(100vh-12rem)]">
      <div>
        <JDList
          jds={jds}
          onSelect={handleSelectJd}
          onEdit={handleEditJd}
          onDelete={handleDeleteJd}
          onAdd={handleAddJd}
          selectedJdId={selectedJdId}
        />
      </div>
      <div>
        {editingJd ? (
          <JDForm
            jd={editingJd}
            onSave={handleSaveJd}
            onCancel={handleCancelEdit}
          />
        ) : (
          <JDDetail
            jd={selectedJd}
            onEdit={handleEditJd}
          />
        )}
      </div>
    </div>
  );
};

export default JDManagementPage;
